import { Pipe, PipeTransform } from '@angular/core';


const isNumber = <T>(value: T | number): value is number => typeof value === 'number' && !isNaN(value);

@Pipe({
    name: 'average',
})
export class AveragePipe implements PipeTransform {

    transform<T>(listings: T[], key: keyof T | ((l: T) => number)) {
        let count = 0;
        let total = 0;
        const keyFn = typeof key === 'function' ? key : (l: T) => l[key as keyof T];
        for (const l of listings) {
            const value = keyFn(l);
            if (isNumber(value)) {
                count++;
                total += value;
            }
        }
        if (count === 0) {
            return;
        }
        return total / count;
    }
}
